import { AutomationsPresentationV1 } from 'Automations/automationEditor'

export const createPresentationFromBaseTemplate = (
  template: AutomationsPresentationV1
): AutomationsPresentationV1 => {
  const idMap = new Map<string, string>()

  for (const node of template.nodes) {
    idMap.set(node.id, crypto.randomUUID())
  }

  const replaceIdsInString = (value: string): string =>
    [...idMap.entries()].reduce(
      (acc, [oldId, newId]) => acc.replaceAll(oldId, newId),
      value
    )

  const nodes = template.nodes.map(node => ({
    ...node,
    id: replaceIdsInString(node.id)
  }))

  const edges = template.edges.map(edge => ({
    ...edge,
    id: replaceIdsInString(edge.id),
    source: replaceIdsInString(edge.source),
    sourceHandle: edge.sourceHandle
      ? replaceIdsInString(edge.sourceHandle)
      : edge.sourceHandle,
    target: replaceIdsInString(edge.target),
    targetHandle: edge.targetHandle
      ? replaceIdsInString(edge.targetHandle)
      : edge.targetHandle
  }))

  return { ...template, nodes, edges }
}
